<template>
  <button @click="$emit('action')"
          :type="buttonType"
          :disabled="loading || disabled"
          :class="{
      'relative flex items-center text-white bg-primary disabled:bg-gray-400 px-6 text-xs lg:text-md lg:px-9 py-2.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent' : type === 'primary',
      'relative flex items-center text-white bg-primary text-base px-20 py-2.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent' : type === 'primary-save',
      'relative flex items-center text-white bg-primary text-base px-32 py-2.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent' : type === 'primary-login',
      'relative flex items-center text-white border border-primary bg-primary px-5 py-1.5 rounded-full transition-all hover:bg-accent hover:border-accent text-sm' : type === 'primary-small',
      'relative flex items-center text-primary border border-primary px-6 text-xs lg:text-md lg:px-9 py-2.5 rounded-full hover:bg-accent hover:border-accent hover:text-white transition-all' : type === 'primary-outline',
      'relative flex items-center text-primary border border-primary px-5 py-1.5 rounded-full hover:bg-accent hover:border-accent hover:text-white transition-all text-sm' : type === 'primary-outline-small',
      'relative hover:underline text-red-500': type === 'primary-text-danger',
      'relative hover:underline text-primary': type === 'primary-text',
      'bg-red-500': isTabSelected,
      }"
          v-bind="$attrs"
  >
    <template v-if="loading === true">
      <span v-if="type === 'primary' || type === 'primary-save' || type === 'primary-login'"
            class="loading-animation-custom-dark"></span>
      <span v-else-if="type === 'primary-small'" class="loading-animation-custom-dark-small"></span>
      <span v-else-if="type === 'primary-outline'" class="loading-animation-custom-white"></span>
      <span v-else-if="type === 'primary-outline-small'"
            class="loading-animation-custom-white-small"></span>
      <span v-else-if="type === 'primary-text-danger'" class="loading-animation-custom-red"></span>
      <span v-else-if="type === 'primary-text'" class="loading-animation-custom-text-primary"></span>
    </template>
    <slot/>
    <span v-if="tooltip && tooltip.length > 0" class="ml-1">
      <AdvancedTooltip :title="tooltip" theme="blue">
        <IconTooltip/>
      </AdvancedTooltip>
    </span>
  </button>
</template>

<script setup lang="ts">

import IconTooltip from "@/components/svg_icons/IconTooltip.vue";
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'primary'
  },
  buttonType: {
    type: String,
    required: false,
    default: 'submit'
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  tooltip: {
    type: String,
    required: false,
    default: ''
  },
  isTabSelected: {
    type: Boolean,
    required: false,
    default: false
  }
});
const emits = defineEmits(["action"]);

</script>